module.exports = __webpack_public_path__ + "images/bg-top-popover.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/bg-top-popover.png
// module id = 830
// module chunks = 130